import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
};

// Admin - Employee Management
export const adminAPI = {
  getEmployees: () => api.get('/admin/employees'),
  getEmployee: (id) => api.get('/admin/employees/' + id),
  createEmployee: (data) => api.post('/admin/employees', data),
  updateEmployee: (id, data) => api.put('/admin/employees/' + id, data),
  deleteEmployee: (id) => api.delete('/admin/employees/' + id),
  resetPassword: (id, newPassword) => api.put('/admin/employees/' + id + '/reset-password?new_password=' + encodeURIComponent(newPassword)),
  getPermissions: () => api.get('/admin/permissions'),
  getActivityLogs: (limit) => api.get('/admin/activity-logs', { params: { limit: limit || 100 } }),
};

// Clients
export const clientsAPI = {
  list: () => api.get('/clients'),
  get: (id) => api.get('/clients/' + id),
  create: (data) => api.post('/clients', data),
  update: (id, data) => api.put('/clients/' + id, data),
  delete: (id) => api.delete('/clients/' + id),
};

// Flotte — téléphones vendus (suivi garantie)
export const soldPhonesAPI = {
  list: (search) => api.get('/sold-phones', { params: search ? { search } : {} }),
  get: (id) => api.get('/sold-phones/' + id),
  create: (data) => api.post('/sold-phones', data),
  update: (id, data) => api.put('/sold-phones/' + id, data),
  delete: (id) => api.delete('/sold-phones/' + id),
};

// Repairs
export const repairsAPI = {
  list: (status) => api.get('/repairs', { params: status ? { status } : {} }),
  get: (id) => api.get('/repairs/' + id),
  create: (data) => api.post('/repairs', data),
  update: (id, data) => api.put('/repairs/' + id, data),
  delete: (id) => api.delete('/repairs/' + id),
  // Photos
  getPhotos: (id) => api.get('/repairs/' + id + '/photos'),
  uploadPhoto: (id, data) => api.post('/repairs/' + id + '/photos', data),
  deletePhoto: (photoId) => api.delete('/photos/' + photoId),
  // Invoice PDF
  uploadInvoicePdf: (id, data) => api.post('/repairs/' + id + '/invoice-pdf', data),
  deleteInvoicePdf: (id) => api.delete('/repairs/' + id + '/invoice-pdf'),
  // Documents
  getIntakeReceipt: (id) => api.get('/repairs/' + id + '/intake-receipt'),
  generateLabel: (id) => api.post('/repairs/' + id + '/generate-label'),
  generateReport: (id) => api.post('/repairs/' + id + '/generate-report'),
};

// Parts
export const partsAPI = {
  list: () => api.get('/parts'),
  get: (id) => api.get('/parts/' + id),
  create: (data) => api.post('/parts', data),
  update: (id, data) => api.put('/parts/' + id, data),
  delete: (id) => api.delete('/parts/' + id),
};

// Invoices
export const invoicesAPI = {
  list: (isQuote) => api.get('/invoices', { params: isQuote !== undefined ? { is_quote: isQuote } : {} }),
  get: (id) => api.get('/invoices/' + id),
  create: (data) => api.post('/invoices', data),
  markPaid: (id) => api.put('/invoices/' + id + '/pay'),
  delete: (id) => api.delete('/invoices/' + id),
};

// Reviews
export const reviewsAPI = {
  list: () => api.get('/reviews'),
  create: (data) => api.post('/reviews', data),
  delete: (id) => api.delete('/reviews/' + id),
};

// Dashboard
export const dashboardAPI = {
  stats: () => api.get('/dashboard/stats'),
  advancedStats: () => api.get('/stats/advanced'),
  alerts: () => api.get('/alerts'),
};

export default api;

// Deposits (Avances)
export const depositsAPI = {
  list: (repairId) => api.get(`/repairs/${repairId}/deposits`),
  add: (repairId, data) => api.post(`/repairs/${repairId}/deposits`, data),
  delete: (repairId, depositId) => api.delete(`/repairs/${repairId}/deposits/${depositId}`),
};
